<div class="loader">
    <div class="center loader__content">
        <div class="animation">
            <div class="background"></div>
            <div class="bottom"></div>
            <div class="top"></div>
        </div>
        <div class="loader__content__title">
            <h2 class="loader__content__title__text">{{ text }}</h2>
        </div>
    </div>
</div>
